import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import {
    WorkstreamDefinitionOperationConfigResponse,
    WorkstreamDefinitionOperationConfigResponseSchema
} from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionOperationConfig';

export const fetchWorkstreamDefinitionOperationConfigs = async (): Promise<WorkstreamDefinitionOperationConfigResponse> => {
    const fetchUrl = '/workactivity/back-office/workstream-definition-operation-config';
    const resp = await fetchFromLambda(fetchUrl, { paginate: true });
    return WorkstreamDefinitionOperationConfigResponseSchema.parse(resp);
};